// extracted by mini-css-extract-plugin
module.exports = {"text":"Feature_text__bPm83"};